import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { QuestionResponseEventCreateInput } from '../generated/globalTypes';
import { createQuestionResponseEventMutation, createQuestionResponseEventMutationVariables } from '../generated/createQuestionResponseEventMutation';
import { questionResponseEventFieldsFragment } from '../models/QuestionResponseEvent';

/**
 * Get a callback to create a QuestionResponseEvent in the store.
 */
export function useCreateQuestionResponseEventCallback(): [(model: QuestionResponseEventCreateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<createQuestionResponseEventMutation, createQuestionResponseEventMutationVariables>(
        gql`
            mutation createQuestionResponseEventMutation ($model: QuestionResponseEventCreateInput!) {
                createQuestionResponseEvent(model: $model) {
                    ...questionResponseEventFields
                }
            }

            ${questionResponseEventFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (model: QuestionResponseEventCreateInput) => {
        const result = await mutationAction({ variables: { model: model } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
